<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <md-field>
        <label>{{$t('mobileMenu.search')}}</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li>
  </ul>
</template>
<script>
export default {
  data () {
    return {
      search: null
    }
  }
}
</script>
